<dg-modal
  #modal
  title="Convidar Pessoa"
  size="sm"
  id="modal-convites-dados"
  [bgClose]="true"
  [beforeClose]="beforeClose"
  (afterClose)="onAfterClose()"
  >
  <div modal-body>
    <form [formGroup]="form">
      <div class="row sp-mt-2">
        <div class="col-12">
          <label class="form-label sp-label">Nome do convidado <span class="text-danger">*</span></label>
          <input
            type="text"
            formControlName="nome"
            class="form-control"
            [class.is-invalid]="form.get('nome')?.invalid && form.get('nome')?.touched"
            >
          @if (form.get('nome')?.invalid && form.get('nome')?.touched) {
            <div class="invalid-feedback">
              @if (form.get('nome')?.errors?.['required']) {
                <span>Nome é obrigatório</span>
              }
            </div>
          }
        </div>
      </div>
      <div class="row sp-mt-2">
        <div class="col-12">
          <label class="form-label sp-label">E-mail do convidado <span class="text-danger">*</span></label>
          <div class="input-group">
            <input
              type="email"
              formControlName="email"
              class="form-control"
              [class.is-invalid]="form.get('email')?.invalid && form.get('email')?.touched"
              >
            @if (showRandomEmailgenerator()) {
              <button
                type="button"
                class="btn btn-outline-secondary"
                (click)="gerarEmailAleatorio()"
                title="Gerar e-mail aleatório"
                aria-label="Gerar e-mail aleatório"
                >
                <mat-icon>refresh</mat-icon>
              </button>
            }
          </div>
          @if (form.get('email')?.invalid && form.get('email')?.touched) {
            <div class="invalid-feedback">
              @if (form.get('email')?.errors?.['required']) {
                <span>E-mail é obrigatório</span>
              }
              @if (form.get('email')?.errors?.['email']) {
                <span>E-mail inválido</span>
              }
            </div>
          }
        </div>
      </div>
      <div class="row sp-mt-2">
        <div class="col-12">
          <label class="form-label sp-label">Lote (opcional)</label>
          <div class="position-relative">
            <input
              type="text"
              class="form-control"
              placeholder="Buscar lote..."
              [formControl]="loteBuscaControl"
              (blur)="ocultarDropdown()"
              autocomplete="off"
              >
            @if (loteSelecionado) {
              <button
                type="button"
                class="btn btn-link position-absolute top-50 end-0 translate-middle-y pe-2 py-0"
                (click)="selecionarLote(null)"
                tabindex="-1"
                >
                <mat-icon style="font-size:16px;line-height:16px;height:16px;width:16px;">close</mat-icon>
              </button>
            }
            @if (mostrarDropdown && lotesFiltrados.length > 0) {
              <ul
                class="list-group position-absolute w-100 shadow-sm"
                style="z-index:1050;max-height:180px;overflow-y:auto;"
                >
                @for (lote of lotesFiltrados; track lote) {
                  <li
                    class="list-group-item list-group-item-action cursor-pointer"
                    (mousedown)="selecionarLote(lote)"
                  >{{ lote.nome }}</li>
                }
              </ul>
            }
          </div>
        </div>
      </div>
      <div class="row sp-mt-2">
        <div class="col-12">
          <label class="form-label sp-label">CPF do convidado (opcional)</label>
          <input
            type="text"
            formControlName="cpf"
            class="form-control"
            placeholder="000.000.000-00"
            mask="000.000.000-00"
            [class.is-invalid]="form.get('cpf')?.invalid && form.get('cpf')?.touched"
            >
          @if (form.get('cpf')?.invalid && form.get('cpf')?.touched) {
            <div class="invalid-feedback">
              @if (form.get('cpf')?.errors?.['cpf']) {
                <span>CPF inválido</span>
              }
            </div>
          }
        </div>
      </div>
    </form>
  </div>
  <div modal-footer>
    <button (click)="salvar()" class="btn btn-primary btn-sm btn-salvar-convite">Enviar</button>
  </div>
</dg-modal>
